/**
 * Helpers de exibição para Agentes IA no Inbox.
 *
 * Regras do produto:
 *  - Sempre mostrar: "<NomeCurto> · Agente IA (<Especialidade>)"
 *  - NomeCurto: primeira parte do nome cadastrado em ia_agentes.nome,
 *    quebrando por travessão/hífen/ponto-médio.
 *    Ex: "Recuperação — Pedido cancelado" -> "Recuperação"
 *  - Especialidade: derivada do nome curto. Mapeamento explícito permite
 *    customizar por agente sem precisar de coluna nova no banco.
 */

const ESPECIALIDADE_POR_NOME: Record<string, string> = {
  // (Douglas 21/08) A Recuperação fala pela MESMA linha da IsabellA e se
  // apresenta igual pro cliente — de propósito, ele não pode sentir que está
  // sendo passado de robô em robô. Quem precisa distinguir é o TIME, no Inbox.
  // Sem isto o selo caía no vermelho genérico e batia o olho como IsabellA.
  // A especialidade sai entre parenteses DEPOIS do nome ("Recuperação · Agente
  // IA (...)"), entao repetir "Recuperação" ali era redundante. Vale a palavra
  // que o time usa pra saber do que a conversa trata: pedido cancelado.
  'recuperação': 'Pedido cancelado',
  recuperacao: 'Pedido cancelado',
};

export function getAgenteNomeCurto(nomeCompleto?: string | null): string {
  if (!nomeCompleto) return 'Agente';
  // Aceita —, –, -, · como separadores
  const primeiraParte = nomeCompleto.split(/\s*[—–\-·]\s*/u)[0]?.trim();
  return primeiraParte || nomeCompleto.trim();
}

export function getAgenteEspecialidade(nomeCompleto?: string | null): string {
  const curto = getAgenteNomeCurto(nomeCompleto).toLowerCase();
  return ESPECIALIDADE_POR_NOME[curto] ?? 'Atendimento';
}

/**
 * Cor do selo por agente: Recuperação = bordô; padrão (IsabellA/Atendimento) = vermelho.
 * Permite distinguir os agentes no inbox sem coluna nova no banco.
 */
export function getAgenteCores(nomeCompleto?: string | null): {
  iconBg: string; nameGrad: string; labelText: string;
} {
  const esp = getAgenteEspecialidade(nomeCompleto);
  if (esp === 'Pedido cancelado') {
    /* Âmbar (--warning) -> bordô: sai do risco e volta pra casa. Token da marca,
       não tailwind cru — e âmbar aqui é legítimo porque é SELO DE STATUS, o uso
       que a lei visual permite pro token semântico; o que ela proíbe é âmbar
       colorindo métrica. */
    return {
      iconBg: 'bg-gradient-to-br from-primary to-brand-borgonha',
      nameGrad: 'bg-gradient-to-r from-primary to-brand-borgonha dark:from-primary dark:to-brand-rose',
      labelText: 'text-primary/90 dark:text-primary/90',
    };
  }
  return {
    iconBg: 'bg-gradient-to-br from-danger to-rose-600',
    nameGrad: 'bg-gradient-to-r from-danger to-rose-500 dark:from-danger dark:to-rose-300',
    labelText: 'text-danger/80 dark:text-danger/80',
  };
}
